import React from 'react';
import { Header } from '../Layouts/Header';
import '../../styles/homepage.css';
import '../../styles/otherpage.css';
import driver from '../../assets/imgs/driver.svg';
import CallToActionButton from '../Layouts/CallToActionButton';
import Footer from '../Layouts/Footer';

export const DriverPage = () => {
  return (
    <div className='home-container'>
      <header className='header-container'>
        <Header action='https://play.google.com/store/apps/details?id=com.emmalion.liontaxidrivers' />
        <div className='hero-container'>
          <div className='intro'>
            <h1>
              <span>
                Become a Driver with{' '}
                <span style={{ color: '#b49714' }}>#1</span> Luxury Cab Service
              </span>
            </h1>
            <h3>Drive & Earn luxuriously</h3>
            <div className='store-buttons'>
              <CallToActionButton
                title='Download Drivers App'
                action='https://play.google.com/store/apps/details?id=com.emmalion.liontaxidrivers'
              />
            </div>
          </div>
          <div className='svg-content'>
            <img src={driver} width={550} height={438} alt='app screenshot' />
          </div>
        </div>
      </header>
      <Footer />
    </div>
  );
};
